/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Info (Info)
 * 
 * 401130001 = Frageeingehend (Nachricht eingehend)
 * 
 * 401130002 = Frageausgehend (Nachricht ausgehend)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceNachrichtentyp {
 Info = 401130000,
 Frageeingehend = 401130001,
 Frageausgehend = 401130002
}

marker([
    "Enum.GlobalEnumsAceNachrichtentyp.Info",
    "Enum.GlobalEnumsAceNachrichtentyp.Frageeingehend",
    "Enum.GlobalEnumsAceNachrichtentyp.Frageausgehend"
]);

export namespace GlobalEnumsAceNachrichtentyp
{
    class DataSets
    {
        static GlobalEnumsAceNachrichtentypDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Info", 401130000, "Info"),
            new EnumValue("Frageeingehend", 401130001, "Nachricht eingehend"),
            new EnumValue("Frageausgehend", 401130002, "Nachricht ausgehend"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceNachrichtentypDataSet;
    }
}
